import React from "react";
import { ACTIONS } from "../state/contexts/quizState";
import { useQuiz } from "../services/hooks/useQuiz";

export default React.memo(function QuizQ12({ isActive }) {
  const { setAnswer, quizResponses } = useQuiz();

  const { monthlyBeautyBudget } = quizResponses;

  const onAnswer = (answer) => {
    setAnswer(ACTIONS.SET_MONTHLY_BEAUTY_BUDGET, {
      monthlyBeautyBudget: answer,
    });
  };

  const options = [
    {
      title: "Less than $25",
    },
    {
      title: "$25 - $50",
    },
    {
      title: "$50 - $100",
    },
    {
      title: "$100 - $200",
    },
    {
      title: "More than $200",
    },
  ];

  const listItems = options.map(({ title }) => (
    <div
      key={title}
      className="quiz-radio-option"
      onClick={() => onAnswer(title)}
    >
      <div className="custom-control custom-radio float-left">
        <input
          type="radio"
          id={title}
          name="monthlyBeautyBudget"
          value={title}
          className="custom-control-input"
          checked={monthlyBeautyBudget === title}
          onChange={(e) => {
            onAnswer(e.target.value);
          }}
        />
        <label className="custom-control-label" htmlFor={title}></label>
      </div>
      <div className="ml-8 quiz-radio-content">
        <p className="font-size-h6">{title}</p>
      </div>
    </div>
  ));

  if (!isActive) {
    return null;
  }

  return (
    <React.Fragment>
      <h4 className="mb-8">
        How much do you estimate you spend on beauty products monthly?
      </h4>

      <div className="quiz-radio-options">{listItems}</div>
    </React.Fragment>
  );
});
